module.exports = __webpack_public_path__ + "img/footerprint_bgmask.27a3891a.png";